import {InjectionToken} from '@angular/core'
import {ExtensionsEmbeddedService} from '@service/extensions-points/extensions.embbeded.service'
import {ExtensionsService} from '@service/extensions-points/extensions.service'
import type {EmbeddedClientService} from '@service/embeddingService/embedded-client.service'

/**
 * Factory que resuelve la implementación adecuada de `ExtensionsService`.
 *
 * @description
 * Devuelve `ExtensionsEmbeddedService` en modo embebido y
 * `ExtensionsService` en modo standalone. El servicio gestiona los
 * puntos de extensión (extension points) que permiten a configuraciones
 * externas inyectar componentes personalizados en zonas concretas de la
 * UI.
 *
 * @param embeddedClientService Cliente que detecta si la app corre embebida.
 * @returns Instancia activa de `ExtensionsService`.
 */
export function providerExtensionsServiceFactory(embeddedClientService: EmbeddedClientService) {
  return embeddedClientService.isEmbeddedFunction() ? new ExtensionsEmbeddedService() : new ExtensionsService()
}

/**
 * `InjectionToken` que referencia la instancia activa de `ExtensionsService`.
 *
 * @description
 * Registrado en `SERVICE_PROVIDERS` junto con
 * {@link providerExtensionsServiceFactory}.
 */
export const ExtensionsServiceToken = new InjectionToken<ExtensionsService>('ExtensionsService')
